import map from "lodash/map"
import groupBy from "lodash/groupBy"
import orderBy from "lodash/orderBy"
import { enableUofAPIs } from "~/constant"
export const state = () => ({
    deleteData: {},
    loading: false,
    cancelLoading: false,
    cancelflag: false,
    totalNoCount: 0,
    totalNoCountPremium: 0,
    totalNoCountPremiumBookmaker: 0,
    error: {},
    matchId: "",
    hideMatch: false,
    hideUnMatch: false,
    betsDatasPremium: [
        {
            name: "Premium SportsBook",
            matchedPremiumSportsBookBets: []
        }
    ],
    betsDatasPremiumBookmaker: [
        {
            name: "Premium Bookmaker",
            matchedPremiumBookmakerBets: []
        }
    ],
    betsDatas: [
        {
            name: "Unmatched Bets",
            unMatchedbets: []
        },
        {
            name: "Matched Bets",
            matchedBets: []
        },
        {
            name: "Line Session",
            lineLadder: []
        }
    ],
    unmatched: {},
    unMatchedbetsLength: undefined,
    average: [],
    matchedBetPremium: [],
    matchedBetBookmakerMarket: [],
    matchedBetPremiumRaw: [],
    consolidate: [],
    isBetCancelling: false
})

export const mutations = {
    set_pertucular_match(state, payload) {
        state.matchId = payload
    },
    empty_matches(state) {
        state.betsDatas[0].unMatchedbets = []
        state.betsDatas[1].matchedBets = []
    },
    empty_data(state) {
        state.deleteData = {}
        state.betsDatas[1].matchedBets = []
        state.betsDatas[0].unMatchedbets = []
        state.error = {}
        state.success = {}
        state.loading = false
        state.matchId = ""
        state.cancelLoading = false
    },
    set_Bets_data_ForParentId(state, betData) {
        state.betsDatas[1].matchedBets = []
        state.betsDatas[0].unMatchedbets = []
        if (betData.value) {
            state.totalNoCount = betData.data.totalCount
            if (betData.data.data.length >= 1) {
                map(betData.data.data, (singleData) => {
                    if (singleData._id.status === "EXECUTION_COMPLETE") {
                        map(singleData.betData, (singlebet) => {
                            if (
                                state.matchId === singlebet.parentCategory._id
                            ) {
                                state.betsDatas[1].matchedBets.push(singlebet)
                                state.betsDatas[1].matchedBets = orderBy(
                                    state.betsDatas[1].matchedBets,
                                    ["placedDate"],
                                    ["desc"]
                                )
                            }
                        })
                    } else {
                        map(singleData.betData, (singlebet) => {
                            if (
                                state.matchId === singlebet.parentCategory._id
                            ) {
                                state.betsDatas[0].unMatchedbets.push(singlebet)
                                state.betsDatas[0].unMatchedbets = orderBy(
                                    state.betsDatas[0].unMatchedbets,
                                    ["placedDate"],
                                    ["desc"]
                                )
                            }
                        })
                    }
                })
                if (state.betsDatas[0].unMatchedbets) {
                    state.unmatched = state.betsDatas[0].unMatchedbets
                    const grouped = groupBy(
                        state.betsDatas[0].unMatchedbets,
                        "event"
                    )
                    state.betsDatas[0].unMatchedbets = map(
                        grouped,
                        (val, key) => {
                            const matchName = groupBy(val, "marketName")
                            const betsDatas = map(matchName, (val, key) => {
                                const horse = groupBy(val, "horse")
                                const result = map(horse, (val, key) => {
                                    return { horse: key, betsDatas: val }
                                })
                                return { matchName: key, result }
                            })
                            return { event: key, betsDatas }
                        }
                    )
                }
                if (state.betsDatas[1].matchedBets) {
                    const grouped = groupBy(
                        state.betsDatas[1].matchedBets,
                        "event"
                    )
                    state.betsDatas[1].matchedBets = map(
                        grouped,
                        (val, key) => {
                            const matchName = groupBy(val, "marketName")
                            const betsDatas = map(matchName, (val, key) => {
                                return { matchName: key, betsDatas: val }
                            })
                            return { event: key, betsDatas }
                        }
                    )
                }
            }
            state.unMatchedbetsLength = state.betsDatas[0].unMatchedbets.length
        } else {
            state.betsDatas[1].matchedBets = []
            state.betsDatas[0].unMatchedbets = []
        }
    },
    set_Bets_data(state, betData) {
        // Initialize state arrays
        const betsData = state.betsDatas
        betsData[0].unMatchedbets = []
        betsData[1].matchedBets = []
        betsData[2].lineLadder = []

        if (!betData.value) {
            state.hideUnMatch = true
            state.hideMatch = true
            return
        }

        state.totalNoCount = betData.data.totalCount
        const betDataArray = betData?.data?.data || []

        if (!betDataArray.length) {
            state.hideUnMatch = betsData[0].unMatchedbets.length === 0
            state.hideMatch = betsData[1].matchedBets.length === 0
            // Not setting the ladder to hide because hidematch is not used.
            return
        }

        // Process all bets
        const allBets = betDataArray.flatMap((singleData) =>
            singleData.bets.map((bet) => ({
                ...bet,
                status: singleData.status
            }))
        )

        // Split into matched/unmatched bets
        const [matchedBets, unmatchedBets] = allBets.reduce(
            (acc, bet) => {
                acc[bet.status === "EXECUTION_COMPLETE" ? 0 : 1].push(bet)
                return acc
            },
            [[], []]
        )

        // Helper function to filter bets by type
        const filterBets = (data, predicate) =>
            data
                .map((match) => ({
                    ...match,
                    markets: match.markets
                        .map((market) => ({
                            ...market,
                            runners: market.runners
                                .map((runner) => ({
                                    ...runner,
                                    bets: runner.bets.filter(predicate),
                                    average: runner.average.filter((avg) =>
                                        predicate(avg)
                                    )
                                }))
                                .filter((runner) => runner.bets.length > 0)
                        }))
                        .filter((market) => market.runners.length > 0)
                }))
                .filter((match) => match.markets.length > 0)

        // Process Line Session and regular matched bets
        const lineLadder = filterBets(
            matchedBets,
            (bet) => bet.betType === "lineLadder"
        )
        const nonLineLadder = filterBets(
            matchedBets,
            (bet) => bet.betType !== "lineLadder"
        )

        // Helper for sorting
        const sortByDate = (arr) => orderBy(arr, ["placedDate"], ["desc"])

        // Update state with sorted results
        betsData[2].lineLadder = sortByDate(lineLadder)
        betsData[1].matchedBets = sortByDate(nonLineLadder)
        betsData[0].unMatchedbets = sortByDate(unmatchedBets)

        // Update derived state
        state.unmatched = betsData[0].unMatchedbets
        state.unMatchedbetsLength = betsData[0].unMatchedbets.length
        state.hideUnMatch = betsData[0].unMatchedbets.length === 0
        state.hideMatch = betsData[1].matchedBets.length === 0
    },
    set_Bets_data2(state, betData) {
        state.betsDatas[1].matchedBets = []
        state.betsDatas[0].unMatchedbets = []
        if (betData.value) {
            state.totalNoCount = betData.data.totalCount
            if (betData.data.data.length >= 1) {
                map(betData.data.data, (singleData) => {
                    if (singleData._id.status === "EXECUTION_COMPLETE") {
                        map(singleData.betData, (singlebet) => {
                            state.betsDatas[1].matchedBets.push(singlebet)
                            state.betsDatas[1].matchedBets = orderBy(
                                state.betsDatas[1].matchedBets,
                                ["placedDate"],
                                ["desc"]
                            )
                        })
                    } else {
                        map(singleData.betData, (singlebet) => {
                            state.betsDatas[0].unMatchedbets.push(singlebet)
                            state.betsDatas[0].unMatchedbets = orderBy(
                                state.betsDatas[0].unMatchedbets,
                                ["placedDate"],
                                ["desc"]
                            )
                        })
                    }
                })
                if (state.betsDatas[0].unMatchedbets) {
                    state.unmatched = state.betsDatas[0].unMatchedbets
                    const grouped = groupBy(
                        state.betsDatas[0].unMatchedbets,
                        "event"
                    )
                    state.betsDatas[0].unMatchedbets = map(
                        grouped,
                        (val, key) => {
                            const matchName = groupBy(val, "marketName")
                            const betsDatas = map(matchName, (val, key) => {
                                const horse = groupBy(val, "horse")
                                const result = map(horse, (val, key) => {
                                    return { horse: key, betsDatas: val }
                                })
                                return { matchName: key, result }
                            })
                            return { event: key, betsDatas }
                        }
                    )
                }
                if (state.betsDatas[1].matchedBets) {
                    const grouped = groupBy(
                        state.betsDatas[1].matchedBets,
                        "event"
                    )
                    state.betsDatas[1].matchedBets = map(
                        grouped,
                        (val, key) => {
                            const matchName = groupBy(val, "marketName")
                            const betsDatas = map(matchName, (val, key) => {
                                return { matchName: key, betsDatas: val }
                            })
                            return { event: key, betsDatas }
                        }
                    )
                }
            }
            state.unMatchedbetsLength = state.betsDatas[0].unMatchedbets.length
        } else {
            state.betsDatas[1].matchedBets = []
            state.betsDatas[0].unMatchedbets = []
        }

        if (state.betsDatas[0].unMatchedbets.length === 0) {
            state.hideUnMatch = true
        } else {
            state.hideUnMatch = false
        }

        if (state.betsDatas[1].matchedBets.length === 0) {
            state.hideMatch = true
        } else {
            state.hideMatch = false
        }
    },

    set_delete_data(state, data) {
        state.deleteData = data
    },
    set_error(state, data) {
        if (data && data.message === "Your bet is already executed") {
            state.error = data.error.message
        } else {
            state.error = data
        }
    },
    set_success(state, data) {
        if (data && data.message === "Your bet is already executed") {
            state.success = data.error.message
        } else {
            state.success = data
        }
    },
    set_loading(state, data) {
        state.loading = data
        state.cancelflag = false
    },
    set_Cancel_loading(state, data) {
        if (data?.betId) {
            // Single Bet
            state.betsDatas[0].unMatchedbets =
                state.betsDatas[0].unMatchedbets.filter(
                    (bet) => bet.betId !== data?.betId
                )
        }
        // else {
        //   // Multiple Bets
        //   state.betsDatas[0].unMatchedbets = []
        // }
        // state.loading = data
        state.cancelflag = true
        state.cancelLoading = data?.value
    },
    set_Bets_data_premium(state, betDataPremium) {
        state.matchedBetPremium = betDataPremium.data
    },
    set_Bets_data_premium_raw(state, betDataPremiumRaw) {
        state.matchedBetPremiumRaw = betDataPremiumRaw.outputArray
        state.totalNoCountPremium = betDataPremiumRaw.totalCount
    },
    set_Bets_Data_Bookmaker_Market(state, betDataBookmakerMarket) {
        if (betDataBookmakerMarket?.data?.outputArray?.length > 0) {
            state.matchedBetBookmakerMarket =
                betDataBookmakerMarket.data.outputArray
            state.totalNoCountPremiumBookmaker =
                betDataBookmakerMarket.data.totalCount
        } else {
            state.matchedBetBookmakerMarket = []
            state.totalNoCountPremiumBookmaker = 0
        }
    },
    remove_Bets_Data_Bookmaker_Market(state) {
        state.matchedBetBookmakerMarket = []
        state.totalNoCountPremiumBookmaker = 0
    },
    set_filters(state, data) {
        const betsData = data?.data?.data

        if (!betsData) return

        // CONSOLIDATE FILTER
        state.consolidate = betsData.filter((bets) => bets.consolidate?.length)
    },
    set_is_bet_cancelling(state, data) {
        state.isBetCancelling = data
    }
}
export const actions = {
    getMyCurrentPremiumBet({ commit, getters }, loading = true) {
        // if (loading) commit('empty_matches')
        // try {
        //   if (getters.cancelflag === false) {
        //     commit('set_loading', loading)
        //   }
        //   const response = await this.$axios({
        //     method: 'post',
        //     baseURL: process.env.PREMIUM_SPORTSBOOK_URL,
        //     url: 'bet/getuserbets',
        //     data: { _accessToken: this.$auth.getToken('customLocal') }
        //   })
        //   if (response.data.value) {
        //     commit('set_Bets_data_premium', response.data)
        //   }
        //   commit('set_loading', false)
        // } catch (error) {
        //   commit('set_error', error)
        //   commit('set_loading', false)
        // }
    },
    async getMyCurrentPremiumRawBet({ commit, getters }, loading = true) {
        if (!enableUofAPIs) return

        // if (loading) commit('empty_matches')
        try {
            if (getters.cancelflag === false) {
                commit("set_loading", loading)
            }
            commit("set_Bets_data_premium_raw", {
                outputArray: [],
                totalCount: 0
            })
            const response = await this.$axios({
                method: "get",
                baseURL: process.env.UOF_SPORTSRADAR_SERVICE_URL,
                url: "/Bet/playerOpenBets"
            })
            if (response.data.success) {
                commit("set_Bets_data_premium_raw", response.data.data)
            }
            commit("set_loading", false)
        } catch (error) {
            commit("set_error", error)
            commit("set_loading", false)
        }
    },
    async getMyCurrentBetStatusBookmakerMarket(
        { commit, getters },
        loading = true
    ) {
        if (getters.isBetCancelling) {
            commit("set_is_bet_cancelling", false)
            return
        }
        const { category } = this.$router?.currentRoute?.params || {}
        const routeName = this.$router?.currentRoute?.name
        if (
            category !== "Cricket" &&
            routeName !== "index" &&
            routeName !== "bets"
        ) {
            // No need to call this API for other games
            commit("set_Bets_Data_Bookmaker_Market", [])
            return
        }
        if (loading) commit("remove_Bets_Data_Bookmaker_Market")
        try {
            if (getters.cancelflag === false) {
                commit("set_loading", loading)
            }
            const response = await this.$axios({
                method: "get",
                baseURL: process.env.PREMIUM_BOOKMAKER_URL,
                url: "bets/playerOpenBets"
            })
            if (
                response?.data?.code === 2000 &&
                response?.data?.msg === "Success"
            ) {
                commit("set_Bets_Data_Bookmaker_Market", response.data)
            }
            commit("set_loading", false)
        } catch (error) {
            commit("set_error", error)
            commit("set_loading", false)
        }
    },
    async getMyCurrentBetStatus({ commit, getters }, loading = true) {
        const dataTObeSend = {}
        if (getters.matchIdData) {
            dataTObeSend.matchId = getters.matchIdData
        }
        dataTObeSend._accessToken = this.$auth.getToken("customLocal")
        try {
            if (getters.cancelflag === false) {
                commit("set_loading", loading)
            }
            const response = await this.$axios({
                method: "post",
                baseURL: process.env.SPORTSBOOK_API_URL,
                url: "Bet/getMyCurrentBetStatusNew2",
                data: dataTObeSend
            })
            if (loading) commit("empty_matches")
            if (response.data.value) {
                commit("set_filters", response.data)
                commit("set_Bets_data", response.data)
            }
            commit("set_loading", false)
        } catch (error) {
            commit("set_error", error)
            commit("set_loading", false)
        }
    },
    async cancelPlayerBet({ commit }, payload) {
        try {
            commit("set_is_bet_cancelling", true)
            commit("set_Cancel_loading", { value: true, betId: payload.betId })
            commit("set_delete_data", {})
            const response = await this.$axios({
                method: "post",
                baseURL: process.env.SPORTSBOOK_API_URL_CANCEL,
                url: "Betfair/cancelPlayerBetNew",
                data: {
                    body: [{ betId: payload.betId, betType: payload.betType }],
                    _accessToken: payload.accessToken
                }
            })
            commit("set_Cancel_loading", { value: false })
            if (response?.data) {
                commit("set_delete_data", response.data)
                commit("set_success", response.data)
            } else if (response.data && !response.data.value) {
                commit("set_error", response.data)
                commit("set_is_bet_cancelling", false)
            } else {
                commit("set_error", "Something went Wrong")
                commit("set_is_bet_cancelling", false)
            }
        } catch (error) {
            commit("set_Cancel_loading", { value: false })
            commit("set_error", error)
            commit("set_is_bet_cancelling", false)
        }
    },
    async cancelPlayerBetPerMatch({ commit }, payload) {
        try {
            commit("set_is_bet_cancelling", true)
            commit("set_Cancel_loading", { value: true })
            commit("set_delete_data", {})
            const response = await this.$axios({
                method: "post",
                baseURL: process.env.SPORTSBOOK_API_URL_CANCEL,
                url: "Betfair/cancelPlayerBetNew",
                data: {
                    body: payload.betArray,
                    _accessToken: payload.accessToken
                }
            })
            commit("set_Cancel_loading", { value: false })
            if (response?.data) {
                commit("set_delete_data", response.data)
                commit("set_success", response.data)
            } else if (response.data && !response.data.value) {
                commit("set_error", response.data)
                commit("set_is_bet_cancelling", false)
            } else {
                commit("set_error", "Something went Wrong")
                commit("set_is_bet_cancelling", false)
            }
        } catch (error) {
            commit("set_Cancel_loading", { value: false })
            commit("set_error", error)
            commit("set_is_bet_cancelling", false)
        }
    }
}

export const getters = {
    matchIdData: (state) => {
        return state.matchId
    },
    cancelflag: (state) => {
        return state.cancelflag
    },
    isBetCancelling: (state) => {
        return state.isBetCancelling
    }
}
